module.exports = __webpack_public_path__ + "static/media/dodaj-kategoriju.4ff2e589.svg";